module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notice) ? _c('el-alert', {
    staticClass: "ai-credits-banner",
    attrs: {
      "type": _vm.notice.type,
      "title": _vm.notice.title,
      "description": _vm.notice.text,
      "show-icon": ""
    },
    on: {
      "close": _vm.dismiss
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30b46d35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/segmentation/common/AiCreditsBanner.vue
// module id = 3204
// module chunks = 3